import TemplatesPage from './TemplatesPage';

export default TemplatesPage;
